import initialState from './../../initialState';

export default (state = initialState.unidade, { type, value, response }) => {
  switch (type) {
    case 'REMOVE_VEHICLE_UNIDADE_SUCCESS':
      return {
        ...state,
        veiculos: {
          ...state.veiculos,
          result: state.veiculos.result.filter(v => v !== value)
        }
      };
    case 'LIST_VEHICLES_UNIDADE_REQUEST':
      return {
        ...state,
        veiculos: {
          ...state.veiculos,
          fetching: 1,
          errors: []
        }
      }
    case 'LIST_VEHICLES_UNIDADE_SUCCESS':
      return {
        ...state,
        veiculos: {
          ...state.veiculos,
          fetching: 2,
          ...response
        }
      }
    case 'DISABLE_MORADOR_UNIDADE_SUCCESS':
      return {
        ...state,
        moradores: {
          ...state.moradores,
          result: state.moradores.result.filter(v => v !== value)
        }
      };
    case 'LIST_MORADORES_UNIDADE_REQUEST':
      return {
        ...state,
        moradores: {
          ...state.moradores,
          fetching: 1,
          errors: []
        }
      }
    case 'LIST_MORADORES_UNIDADE_SUCCESS':
      return {
        ...state,
        moradores: {
          ...state.moradores,
          fetching: 2,
          ...response
        }
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/modules/unidade/reducer.js